import {
    CLEAR_AVAILABILITY,
    SET_AVAILABILITY,
    SET_OBJECT_ID_BUSY,
    SET_OBJECTS,
    SET_ROOM_ID,
    SET_ROOMS
} from "./constans";
import {roomsApi} from "../../API/API";
import {getRoomsList} from "../../globalState/object/actions";
import {updateSavingStatus} from "../../globalState/app/actions";


export const setAvailability = (payload) => {
    return {
        type: SET_AVAILABILITY,
        payload
    }
};

export const clearAvailability = () => {
    return {
        type: CLEAR_AVAILABILITY,

    }
};
export const setRooms = (payload) => {
    return {
        type: SET_ROOMS,
        payload
    }
};

export const setObjects = (payload) => {
    return {
        type: SET_OBJECTS,
        payload
    }
};


export const setObjectId = (payload) => {
    return {
        type: SET_OBJECT_ID_BUSY,
        payload
    }
};

export const setRoomId = (payload) => {
    return {
        type: SET_ROOM_ID,
        payload
    }
};




export const getAvailabilityObjectsList = (objectSubscriber) => async (dispatch) => {

    let filtredObjects = []

    objectSubscriber && Object.keys(objectSubscriber).map(object => {
        if (objectSubscriber[object].paymentType === "percent") {
            filtredObjects.push({id: objectSubscriber[object].id, name: objectSubscriber[object].name})
        }
    })

    let objectId = filtredObjects[0]?.id

    dispatch(setObjects(filtredObjects))
    dispatch(setObjectId(objectId))


}

export const getRoomsListForAvailibility = (formData) => async (dispatch) => {
    let response = await roomsApi.getList(formData);

    if (response.status) {
        dispatch(setRooms(response.data))
        dispatch(setRoomId(response.data[0]?.id))

    }
}

export const changeObject = (object) => (dispatch) => {
    dispatch(setAvailability({}))
    dispatch(setObjectId(object))
}

export const changeRoom = (room) => (dispatch) => {
    dispatch(setRoomId(room))
}



export const updateAvailability = (availability) => async (dispatch) => {
    dispatch(updateSavingStatus({status: "loading"}))
    let response = await roomsApi.updateAvailability(availability);

    if (response.status) {
        dispatch(updateSavingStatus({status: "success"}))
        dispatch(getRoomsList({object: availability.object}))
        return dispatch(updaterAvailability(response))
    } else {
        dispatch(updateSavingStatus({status: "error", message: response.data.message}))
    }
}

export const getAvailabilityTable = (formData) => async (dispatch) => {
    let response = await roomsApi.getAvailability(formData);

    if (response.status) {
        dispatch(updaterAvailability(response))
    }
}

export const removeAvailability = () => (dispatch) => {
    dispatch(clearAvailability())
}


export const updaterAvailability = (response) => async (dispatch) => {
    let data = response.data
    let availability = response.data.availability

    let today = new Date()
    let thisYear = today.getFullYear()
    let thisMonth = today.getMonth()


    let newAvailability = {}
    for (let i = 0; i <= 23; i++) {
        let month = new Date(thisYear, thisMonth + i)
        let lastDayOfMonth = new Date(thisYear, thisMonth + i + 1, 0).getDate()

        for (let k = 1; k <= lastDayOfMonth; k++) {

            let newDate = new Date(month.getFullYear(), month.getMonth(), k).toLocaleDateString('ru-RU').split(".").reverse().join("-")

            let disabled = new Date(newDate).getTime() + 86400000 < today.getTime()



            if (availability && availability.hasOwnProperty(newDate)) {
                newAvailability = {...newAvailability, [newDate]: {...availability[newDate], disabled: disabled}}
            } else {
                newAvailability = {...newAvailability, [newDate]: {count: "", disabled: disabled}}
            }

        }
    }

    return dispatch(setAvailability({...data, availability: newAvailability}))
}


